import { tickerItems } from '@/mocks/content';

export default function TickerRibbon() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="overflow-hidden border-y border-accent-700/30 bg-accent-600 py-2 text-background-50">
      <div className="flex w-max animate-marquee items-center gap-10 px-4">
        {doubled.map((item, idx) => (
          <a
            key={`${item.id}-${idx}`}
            href="#feed"
            className="flex shrink-0 items-center gap-2.5 whitespace-nowrap text-sm"
          >
            <span
              className={`rounded-full px-2 py-0.5 text-[11px] font-bold leading-none ${
                item.label === '爆'
                  ? 'bg-background-50 text-accent-600'
                  : 'bg-background-50/25 text-background-50'
              }`}
            >
              {item.label}
            </span>
            <span className="text-background-50/90">{item.text}</span>
            <i className="ri-record-circle-fill text-[8px] text-background-50/50" />
          </a>
        ))}
      </div>
    </div>
  );
}